import React from 'react'
import { debounce } from 'shared/utils/debounce'

interface ISize {
  width: number
  height: number
}

const debounceFunc = debounce(
  (setWindowSize: React.Dispatch<React.SetStateAction<ISize>>) =>
    setWindowSize({ width: window.innerWidth, height: window.innerHeight }),
  500,
)

// TODO: really sus code, check if it useful
export default function useWindowSize(): ISize {
  const [windowSize, setWindowSize] = React.useState<ISize>({
    width: 1200,
    height: 800,
  })

  function changeWindowSize(): void {
    debounceFunc(setWindowSize)
  }

  React.useEffect(() => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight })
    window.addEventListener('resize', changeWindowSize)

    return (): void => {
      window.removeEventListener('resize', changeWindowSize)
    }
  }, [])

  return windowSize
}
